/*
  Complete Checkbox

  Handles checkbox clicks, updates the late status, etc.

  EMITTED EVENTS
    completable:checkbox-update (document) Emitted when checkbox update request completes successfully
      detail: {
        el: the root element of this controller instance
      }
*/

import { xhrRequest, createCustomEvent } from '../../shared/helpers';

class CompleteCheckboxController extends Controller {
  static targets = ['checkbox', 'label']

  connect() {
    this.updateCheckboxMaybe = this.updateCheckboxMaybe.bind(this);
    this.setHTMLState({ isChecked: this.checkbox.checked })
    App.Helpers.listenToCustomEvent(document, "completable:checkbox-update", this.updateCheckboxMaybe);
  }

  disconnect() {
    App.Helpers.removeCustomEventListener(document, "completable:checkbox-update", this.updateCheckboxMaybe);
  }

  updateCheckboxMaybe({ detail }) {
    const { el } = detail;
    const otherCheckbox = App.ControlledComponents.findControllerBy({ element: el, name: "complete-checkbox" });
    if (otherCheckbox != this && otherCheckbox && otherCheckbox.objectID && otherCheckbox.objectID == this.objectID && otherCheckbox.objectType == this.objectType) {
      this.checked = otherCheckbox.checked;
    }
  }

  updateComplete(event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    if (!this.isDisabled) {
      this.label.classList.remove('skip-animation');

      const newStatus = this.nextState
      this.checked = newStatus

      App.Helpers.ajaxRequest({
        url: this.url,
        method: "put",
        data: { [this.objectType]: { complete: newStatus }},
        successHandler: (data => {
          this.checked = data.complete;
          document.dispatchEvent(createCustomEvent('completable:checkbox-update', this.element, data));
          this.siblingController && (this.siblingController.checked = data.complete);
          this.updateIsLate(data);
        }).bind(this)
      })
    }
  }

  //
  // INTERNAL USE
  //

  setHTMLState({ isChecked }) {
    this.data.set('state', (isChecked ? 'checked' : 'unchecked'))
    this.label.classList[this.checked ? 'add' : 'remove']('active-checkbox')
  }

  updateIsLate(data) {
    const addOrRemove = !data.complete && moment(data.due_date).isBefore(moment(), 'day') ? 'add' : 'remove';
    this.parentContainer && this.parentContainer.classList[addOrRemove]('is-late');
  }

  //
  // GETTERS AND SETTERS
  //

  get url() {
    return this.data.get('url')
  }

  get checkbox() {
    return this.checkboxTarget
  }

  get label() {
    return this.labelTarget
  }

  get checked() {
    return this.data.get('state') === 'checked'
  }

  set checked(val) {
    this.setHTMLState({ isChecked: val })
    this.checkbox.checked = val
    this.parentContainer && this.parentContainer.classList[val ? 'add' : 'remove']('complete')
  }

  get nextState() {
    return !this.checked
  }

  get parentContainer() {
    return this.data.has('parent-selector') && this.element.closest(this.data.get('parent-selector'))
  }

  get objectType() {
    return this.data.get('object-type')
  }

  get objectID() {
    return this.data.get("object-id")
  }

  get siblingController() {
    const element = this.parentContainer && [...this.parentContainer.querySelectorAll('.via-checkbox')].find(el => el !== this.element);
    return element && this.application.getControllerForElementAndIdentifier(element, 'complete-checkbox');
  }

  get isDisabled() {
    return ["1", 1, true, "true"].includes(this.data.get("disabled"));
  }
}

export default CompleteCheckboxController



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/complete-checkbox-controller.js